import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import VueFormWizard from 'vue-form-wizard'; // Add this
import 'vue-form-wizard/dist/vue-form-wizard.min.css'; // Default CSS

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/css/app.scss';
import { removeSeoLanding } from './utils/seo';

const { version } = require('../package.json');

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueLodash, { name: 'custom', lodash: lodash });
Vue.use(VueFormWizard); // Register the wizard

Vue.config.productionTip = false;

new Vue({
  router,
  data: { appVersion: version },
  render: h => h(App),
  mounted() {
    removeSeoLanding();
  },
}).$mount('#app');
